/**
 * User Companies Data Source
 */

import type { 
  DataSourceModule, 
  FieldMetadata, 
  ColumnDefinition, 
  ListWidgetItem,
  TableDataOutput,
  DataSourceConfig 
} from '../types';
import { Company } from "@/types-games";
import { formatDate } from '../shared/formatters';

// Field definitions with metadata
const fields: Record<string, FieldMetadata> = {
  id: {
    type: 'string',
    editable: false,
    filterable: true,
    sortable: true,
  },
  name: {
    type: 'string',
    editable: 'text',
    filterable: true,
    sortable: true,
    required: true,
  },
  subscription: {
    type: 'string',
    editable: false,
    filterable: true,
    sortable: true,
  },
  created_at: {
    type: 'date',
    editable: false,
    filterable: false,
    sortable: true,
    formatter: formatDate
  }
};

// Column definitions
const columns: ColumnDefinition[] = [
  { key: 'name', label: 'Company Name', filterable: true, metadata: fields.name },
  { key: 'subscription', label: 'Subscription', filterable: true, metadata: fields.subscription },
  { key: 'created_at', label: 'Created', align: 'left', metadata: fields.created_at }
];

// Configuration
const config: DataSourceConfig = {
  type: 'user-companies',
  title: 'User Companies',
  description: 'Companies the user belongs to',
  expandable: false,
};

// Data fetcher (companies are fetched from provider, pass them in)
function fetchData(selectedGame?: any, selectedFolderId?: string | null, companies?: Company[]): Company[] {
  return companies || [];
}

// Transformers
function toList(rawData: Company[]): ListWidgetItem[] {
  return rawData.map(company => ({
    name: company.name,
    tags: 'Company',
    type: 'Company',
    created_at: company.created_at,
    data: { subscription: company.subscription || 'No subscription' },
    updated_at: company.created_at,
    description: company.subscription || 'No subscription'
  }));
}

function toTable(rawData: Company[]): TableDataOutput {
  return {
    columns,
    data: rawData.map(company => ({
      id: company.id,
      name: String(company.name),
      subscription: String(company.subscription || 'No subscription'),
      created_at: formatDate(company.created_at)
    })),
    metadata: {
      totalCount: rawData.length,
      filteredCount: rawData.length
    }
  };
}

// Export the module
export const userCompaniesDataSource: DataSourceModule = {
  type: 'user-companies',
  config,
  fields,
  columns,
  fetchData,
  transformers: {
    toList,
    toTable
  }
};

